export * from './checklist'
export * from './notification'
export * from './supplier'
export * from './tenant'
export * from './user'
export * from './fleet'
export * from './damage'
export * from './maintenance'
export * from './assistance'
export * from './settings'
export * from './aggregates'
export * from './autoApproval'
export * from './invoice'
export * from './money'

// Firestore path helpers — single source of truth for collection paths
export const firestorePaths = {
  tenant: (tenantId: string) => `tenants/${tenantId}`,
  tenantUsers: (tenantId: string) => `tenants/${tenantId}/users`,
  tenantUser: (tenantId: string, userId: string) => `tenants/${tenantId}/users/${userId}`,
  fleets: (tenantId: string) => `tenants/${tenantId}/fleets`,
  fleet: (tenantId: string, fleetId: string) => `tenants/${tenantId}/fleets/${fleetId}`,
  trailers: (tenantId: string) => `tenants/${tenantId}/trailers`,
  trailer: (tenantId: string, trailerId: string) => `tenants/${tenantId}/trailers/${trailerId}`,
  trailerDocuments: (tenantId: string, trailerId: string) => `tenants/${tenantId}/trailers/${trailerId}/documents`,
  trailerDocument: (tenantId: string, trailerId: string, docId: string) => `tenants/${tenantId}/trailers/${trailerId}/documents/${docId}`,
  damages: (tenantId: string) => `tenants/${tenantId}/damages`,
  damage: (tenantId: string, damageId: string) => `tenants/${tenantId}/damages/${damageId}`,
  damageComments: (tenantId: string, damageId: string) =>
    `tenants/${tenantId}/damages/${damageId}/comments`,
  damageEstimates: (tenantId: string, damageId: string) =>
    `tenants/${tenantId}/damages/${damageId}/estimates`,
  damageEstimate: (tenantId: string, damageId: string, estimateId: string) =>
    `tenants/${tenantId}/damages/${damageId}/estimates/${estimateId}`,
  damageActivity: (tenantId: string, damageId: string) =>
    `tenants/${tenantId}/damages/${damageId}/activity`,
  notifications: (tenantId: string) => `tenants/${tenantId}/notifications`,
  notification: (tenantId: string, notificationId: string) => `tenants/${tenantId}/notifications/${notificationId}`,
  maintenanceRecords: (tenantId: string) => `tenants/${tenantId}/maintenance`,
  maintenanceRecord: (tenantId: string, recordId: string) => `tenants/${tenantId}/maintenance/${recordId}`,
  maintenanceComments: (tenantId: string, recordId: string) =>
    `tenants/${tenantId}/maintenance/${recordId}/comments`,
  maintenanceComment: (tenantId: string, recordId: string, commentId: string) =>
    `tenants/${tenantId}/maintenance/${recordId}/comments/${commentId}`,
  assistanceRequests: (tenantId: string) => `tenants/${tenantId}/assistance`,
  assistanceRequest: (tenantId: string, requestId: string) => `tenants/${tenantId}/assistance/${requestId}`,
  tenantSettings: (tenantId: string) => `tenants/${tenantId}/settings`,
  notificationSettings: (tenantId: string) => `tenants/${tenantId}/settings/notifications`,
  slaSettings: (tenantId: string) => `tenants/${tenantId}/settings/sla`,
  emailLogs: (tenantId: string) => `tenants/${tenantId}/emailLogs`,
  emailLog: (tenantId: string, logId: string) => `tenants/${tenantId}/emailLogs/${logId}`,
  suppliers: (tenantId: string) => `tenants/${tenantId}/suppliers`,
  supplier: (tenantId: string, supplierId: string) => `tenants/${tenantId}/suppliers/${supplierId}`,
  autoApprovalSettings: (tenantId: string) => `tenants/${tenantId}/settings/autoApproval`,
  aggregates: (tenantId: string) => `tenants/${tenantId}/aggregates`,
  dashboardAggregate: (tenantId: string) => `tenants/${tenantId}/aggregates/dashboard`,
  estimateBaselines: (tenantId: string) => `tenants/${tenantId}/aggregates/estimateBaselines`,
  checklistTemplates: (tenantId: string) => `tenants/${tenantId}/checklistTemplates`,
  checklistTemplate: (tenantId: string, templateId: string) => `tenants/${tenantId}/checklistTemplates/${templateId}`,
  checklistExecutions: (tenantId: string) => `tenants/${tenantId}/checklistExecutions`,
  checklistExecution: (tenantId: string, execId: string) => `tenants/${tenantId}/checklistExecutions/${execId}`,
  supplierInvoices: (tenantId: string) => `tenants/${tenantId}/supplierInvoices`,
  supplierInvoice: (tenantId: string, invoiceId: string) => `tenants/${tenantId}/supplierInvoices/${invoiceId}`,
  creditNotes: (tenantId: string) => `tenants/${tenantId}/creditNotes`,
  creditNote: (tenantId: string, creditNoteId: string) => `tenants/${tenantId}/creditNotes/${creditNoteId}`,
} as const
